<template>
    <div class="form-group--border">
        <div v-if="item" class="scrollable-content">
            <div class="pmpk-view">
                <div class="row" v-if="item.isArchive">
                    <div class="form-group col-3">
                        <label class="control-label">Дата архивирования</label>
                        <div>
                        {{
                            $momentFormat(
                            item.archiveDate,
                            "DD.MM.YYYY HH:mm"
                            )
                        }}
                        </div>
                    </div>
                    <div class="form-group col-9">
                        <label class="control-label">Автор</label>
                        <div>{{ item.user.fullName }}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-3 required">
                        <label class="control-label">№ заключения</label>
                        <ComponentInput v-model="item.number" :max-length="100" required :disabled="disabled"/>
                    </div>
                    <div class="form-group col-3 required">
                        <label class="control-label">Дата прохождения ПМПК</label>
                        <date-component
                            :clearable="false"
                            :disabled="isReadonly"
                            v-model="item.passDate"
                            :required="true"
                            :notFuture="true"
                            scopeName="tabConclusion"
                            v-if="!disabled"
                            />
                        <ComponentInput v-bind:modelValue="$momentFormat(item.passDate, 'DD.MM.YYYY')" v-else disabled="true" />
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-6 select2 required">
                        <ComponentInput
                            label="ПМПК"
                            type="select2"
                            required
                            :select2Options="pmpkPlacements"
                            :select2Settings="select2Settings"
                            v-model="item.pmpkPlacementId"
                            :disabled="disabled"
                        />
                    </div>
                    <div class="form-group col-6 select2 required" v-if="Number(item.pmpkPlacementId) === 2">
                        <ComponentInput
                            label="Муниципальный район"
                            type="select2"
                            required
                            :select2Options="districts"
                            :select2Settings="select2Settings"
                            v-model="item.districtId"
                            :disabled="disabled"
                            />
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-12 required">
                        <label class="control-label">Выводы комиссии</label>
                        <textarea v-model="item.commissionConclusions" class="form-control" v-if="!disabled"
                                  rows="3"></textarea>
                        <div v-else class="form-control form-control-text">{{item.commissionConclusions}}</div>
                        <div
                            class="invalid-msg"
                            v-if="v$.item.commissionConclusions.$error"
                            >
                            Введите данные
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-12 select2 required">
                        <component-input
                            label="Уровень образования"
                            type="select2"
                            required
                            :select2Options="educationLevels"
                            :select2Settings="select2Settings"
                            v-model="eduLevelId"
                            v-on:select2OnSelect="loadEducationalPrograms"
                            :disabled="disabled"
                            />
                    </div>
                    <div class="form-group col-12 select2 required">
                        <component-input
                            label="Образовательная программа"
                            type="select2"
                            required
                            :select2Options="educationalPrograms"
                            :select2Settings="select2Settings"
                            v-model="item.educationalProgramId"
                            v-on:select2OnSelect="loadRecommendations"
                            :disabled="disabled"
                            />
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-6 select2 required">
                        <component-input
                            label="Срок реализации"
                            scopeName="tabConclusion"
                            type="select2"
                            required
                            :select2Options="realizationTerms"
                            :select2Settings="select2Settings"
                            v-model="item.realizationTermId"
                            :disabled="disabled"
                            />
                    </div>
                    <div class="form-group col-6 select2 required">
                        <component-input
                            label="Срок повторного обследования"
                            scopeName="tabConclusion"
                            type="select2"
                            required
                            :select2Options="repeatPeriods"
                            :select2Settings="select2Settings"
                            v-model="item.repeatPeriodId"
                            :disabled="disabled"
                            />
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-12">
                        <label class="control-label">Специальные методы обучения</label>
                        <ComponentInput v-model="item.specialTeachingMethods" :disabled="disabled" />
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-12">
                        <label class="control-label">Специальные учебные пособия и дидактические материалы</label>
                        <Select2
                            :options="specialTutorials"
                            :settings="{ multiple: true, language: 'ru' }"
                            v-model="item.specialTutorials"
                            v-if="!disabled"
                            />
                        <div v-else class="form-control form-control-text">{{item.specialTutorials.map((x)=>x.specialTutorial.name).join('; ')}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-12">
                        <label class="control-label">Специальные ТСО коллективного и индивидуального пользования</label>
                        <Select2
                            :options="specialTso"
                            :settings="{ multiple: true, language: 'ru' }"
                            v-model="item.specialTso"
                            v-if="!disabled"
                            />
                        <div v-else class="form-control form-control-text">{{item.specialTso.map((x)=>x.specialTso.name).join('; ')}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-12">
                        <label class="control-label">Сопровождение специалистами</label>
                        <Select2
                            :options="specialists"
                            :settings="{ multiple: true, language: 'ru' }"
                            v-model="item.specialists"
                            v-if="!disabled"
                            />
                        <div v-else class="form-control form-control-text">{{item.specialists.map((x)=>x.specialist.name).join('; ')}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-12">
                        <label class="control-label">Другие специальные условия</label>
                        <textarea v-model="item.specialConditions" class="form-control" v-if="!disabled"
                                  rows="3"></textarea>
                        <div v-else class="form-control form-control-text">{{item.specialConditions}}</div>
                    </div>
                </div>
                <h5>Рекомендации по психолого-педагогическому и логопедическому сопровождению</h5>
                <div class="row">
                    <div class="form-group col-12">
                        <label class="control-label">по педагогическому</label>
                        <Select2
                            :options="recom.pedagogical"
                            :settings="{ multiple: true, language: 'ru' }"
                            v-model="item.recomPedagogical"
                            v-if="!disabled"
                            />
                        <div v-else class="form-control form-control-text">{{item.recomPedagogical.map((x)=>x.recomPedagogical.name).join('; ')}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-12">
                        <label class="control-label">по психологическому</label>
                        <Select2
                            :options="recom.psychological"
                            :settings="{ multiple: true, language: 'ru' }"
                            v-model="item.recomPsychological"
                            v-if="!disabled"
                            />
                        <div v-else class="form-control form-control-text">{{item.recomPsychological.map((x)=>x.recomPsychological.name).join('; ')}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-12">
                        <label class="control-label">по логопедическому</label>
                        <Select2
                            :options="recom.speechtherapy"
                            :settings="{ multiple: true, language: 'ru' }"
                            v-model="item.recomSpeechTherapy"
                            v-if="!disabled"
                            />
                        <div v-else class="form-control form-control-text">{{item.recomSpeechTherapy.map((x)=>x.recomSpeechTherapy.name).join('; ')}}</div>
                    </div>
                </div>
                <hr/>
                <div class="row">
                    <div class="form-group col-12">
                        <label class="control-label">Рекомендации по прохождению ГИА по ОП основного и среднего общего образования</label>
                        <textarea v-model="item.recomGia" class="form-control" v-if="!disabled"
                                  rows="3"></textarea>
                        <div v-else class="form-control form-control-text">{{item.recomGia}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class='control-label'>Копия заключения</label>
                            <file-upload
                                width="100%"
                                :entity="item"
                                @deleteFile="removeConclusionCopyFile"
                                prop-name="conclusionCopy"
                                @uploaded="conclusionCopyFileUploaded"
                                label="Нет файла" :readonly="disabled"
                            />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group required">
                            <label class='control-label'>Согласие на добавление заключения ПМПК в Регистр ЛРАС</label>
                            <file-upload
                                width="300px"
                                :entity="item"
                                @deleteFile="removeConclusionConsentToAddFile"
                                prop-name="consentToAdd"
                                @uploaded="conclusionConsentToAddFileUploaded"
                                label="Нет файла" :readonly="disabled"
                            />
                            <div
                                class="invalid-msg"
                                v-if="v$.item.consentToAddId.$error"
                            >
                                Загрузите файл
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-12">
                            <label class="control-label">Иные документы</label>
                            <div class="general-info__wrapper">
                                <div class="form-group form-group--files">
                                    <div class="d-flex flex-column">
                                    <div v-if="!item.files.length">
                                        Нет прикрепленных файлов
                                    </div>
                                    <div class="d-flex flex-column">
                                        <div class="d-flex flex-wrap gap-3">
                                            <div v-for="(file, index) in item.files" :key="index">
                                                <div class="d-flex align-items-center">
                                                    <div class="flex-column">
                                                    <FileUpload
                                                        width="300px"
                                                        @deleteFile="removeFile(index)"
                                                        :entity="file"
                                                        prop-name="file"
                                                        :entity-index="index"
                                                        @uploaded="fileUploaded"
                                                        :readonly="disabled"
                                                    />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <button
                                        class="btn btn-addFile shadow-none"
                                        title="Добавить"
                                        @click="addFile"
                                        v-if="!disabled"
                                        >
                                        Прикрепить документ
                                        </button>
                                    </div>
                                    </div>
                                </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="float-right d-flex align-items-center mt-4">
                <button-component class="btn btn-primary mx-2" 
                    v-if="!disabled" 
                    :disabled="inProgress" 
                    v-on:click="save">
                        <i class="fa fa-spinner fa-spin mr-2" v-if="inProgress"> </i>
                        Сохранить</button-component>
                <button-component type="button" kind="secondary" class="btn" v-on:click="close">Закрыть</button-component>
            </div>
        </div>
    </div>
</template>

<script>
  import DateComponent from "@/common/components/DateComponent";
  import ButtonComponent from "@/common/ui/ButtonComponent";
  import Api from "../api/pmpk";
  import NsiApi from "../../admin/api/nsi";
  import ComponentInput from "@/common/components/ComponentInput";
  import FileUpload from "@/common/components/FileUpload";
  import Constants from "@/common/constants";
  import { useVuelidate } from "@vuelidate/core";
  import { maxLength, required, requiredIf } from "@vuelidate/validators";

  export default {
    name: "PmpkConclusionCard",
    components: {FileUpload, ComponentInput, ButtonComponent, DateComponent},
    props: {
      pmpkId: { type: Number },
      journalId: { type: Number },
      id: { type: Number },
      readonly: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        item: null,
        disabled: this.readonly,
        select2Settings: Constants.select2Settings,
        eduLevelId: null,

        pmpkPlacements: [],
        districts: [],
        educationLevels: [],
        educationalPrograms: [],
        realizationTerms: [],
        repeatPeriods: [],
        recom: {
            speechtherapy: [],
            pedagogical: [],
            psychological: [],
        },
        specialTutorials: [],
        specialTso: [],
        specialists: [],

        inProgress: false,
      };
    },
    created() {
      this.loadDictionaries();
      if(this.id)
        this.loadCard();
      else 
        this.conclusionTemplate();
    },
    methods: {
      conclusionTemplate() {
        this.item = {
            id: 0,
            passDate: null,
            number: "",
            pmpkPlacementId: null,
            districtId: null,
            educationalProgramId: null,
            realizationTermId: null,
            repeatPeriodId: null,
            files: [],
            specialTeachingMethods: "В соответствии с программой",
            specialTutorials: [],
            specialTso: [],
            specialists: [],
            specialConditions: null,
            recomPedagogical: [],
            recomPsychological: [],
            recomSpeechTherapy: [],
            recomGia: null,
            isArchive: false,
        };
      },
      loadCard() {
        Api.findConclusion(this.id)
          .then((response) => {
            this.item = response.data;
            this.eduLevelId = this.item.educationalProgram?.educationLevelId;
            if(this.item.isArchive) {
                this.disabled = true;
            } 
            if(!this.disabled) {
                if (this.item.specialTutorials.length) {
                    this.item.specialTutorials =this.item.specialTutorials.map(
                        (x) => x.specialTutorialId
                    );
                }
                if (this.item.specialTso.length) {
                    this.item.specialTso = this.item.specialTso.map(
                        (x) => x.specialTsoId
                    );
                }
                if (this.item.specialists.length) {
                    this.item.specialists = this.item.specialists.map((x) => x.specialistId);
                }
                if (this.item.recomPsychological.length) {
                    this.item.recomPsychological = this.item.recomPsychological.map(
                        (x) => x.recomPsychologicalId
                        );
                }
                if (this.item.recomPedagogical.length) {
                    this.item.recomPedagogical = this.item.recomPedagogical.map(
                        (x) => x.recomPedagogicalId
                        );
                }
                if (this.item.recomSpeechTherapy.length) {
                    this.item.recomSpeechTherapy = this.item.recomSpeechTherapy.map(
                        (x) => x.recomSpeechTherapyId
                        );
                }
            }

            this.loadEducationalPrograms();
            this.loadRecommendations();
          });
      },
      loadDictionaries() {
        NsiApi.getNsi("pmpkplacement").then((response) => {
            this.pmpkPlacements = response.data;
        });
        NsiApi.getNsi("district").then((response) => {
            this.districts = response.data;
        });
        NsiApi.getNsi("realizationterm").then((response) => {
            this.realizationTerms = response.data;
        });
        NsiApi.getNsi("educationlevel").then((response) => {
            this.educationLevels = response.data;
        });
        NsiApi.getNsi("repeatperiod").then((response) => {
            this.repeatPeriods = response.data;
        });
        NsiApi.getNsi("specialtutorial").then((response) => {
            this.specialTutorials = response.data;
        });
        NsiApi.getNsi("specialtso").then((response) => {
            this.specialTso = response.data;
        });
        NsiApi.getNsi("specialist").then((response) => {
            this.specialists = response.data;
        });
      },
      loadEducationalPrograms() {
        if (!this.eduLevelId) {
            return;
        }
        NsiApi.getEducationalPrograms(this.eduLevelId).then((response) => {
            this.educationalPrograms = response.data;
        });
      },
      loadRecommendations() {
        if (!this.item.educationalProgramId) {
            return;
        }
        const recom = ["speechtherapy", "pedagogical", "psychological"];
            recom.forEach((rec) => {
                NsiApi.getRecommedations(
                    rec,
                    this.item.educationalProgramId
                ).then((response) => {
                    this.recom[rec] = response.data;
                });
            });
      },
      conclusionCopyFileUploaded(e) {
        this.item.conclusionCopy = e.data;
        this.item.conclusionCopyId = e.data ? e.data.id : null;
        },
        removeConclusionCopyFile() {
        this.item.conclusionCopyId = null;
        this.item.conclusionCopy = null;
        },
      conclusionConsentToAddFileUploaded(e) {
        this.item.consentToAdd = e.data;
        this.item.consentToAddId = e.data ? e.data.id : null;
        },
        removeConclusionConsentToAddFile() {
        this.item.consentToAdd = null;
        this.item.consentToAddId = null;
        },
      addFile() {
        var attachedFile = { journalPmpkConclusionId: this.id, fileId: 0 };
        this.item.files = [
            ...this.item.files,
            attachedFile,
        ];
        },
        removeFile(idx) {
        this.item.files.splice(idx, 1);
        },
      fileUploaded(e) {
        let entity = this.item.files[e.entityIndex];
        entity[e.propName + "Id"] = e.data.id;
        entity[e.propName] = e.data;
        },
      close() {
        this.$emit('close');
      },
      save() {
        this.inProgress = true;
        
        this.v$.$touch();
        if (this.v$.$invalid) {
            Constants.alert.fire(
            "Ошибка",
            "Проверьте правильность заполнения полей",
            "error"
            );
            this.inProgress = false;
            return;
        }

        

        //подготовка данных перед сохранением
        const itemToSave = Object.assign({}, this.item);
        itemToSave.documents = null;
        itemToSave.employments = null;
        itemToSave.educations = null;

        itemToSave.specialists = itemToSave.specialists.map((x) => ({ specialistId: x }));
        itemToSave.specialTutorials = itemToSave.specialTutorials.map((x) => ({ specialTutorialId: x }));
        itemToSave.specialTso = itemToSave.specialTso.map((x) => ({ specialTsoId: x }));
        itemToSave.recomPsychological = itemToSave.recomPsychological.map((x) => ({ recomPsychologicalId: x }));
        itemToSave.recomPedagogical = itemToSave.recomPedagogical.map((x) => ({ recomPedagogicalId: x }));
        itemToSave.recomSpeechTherapy = itemToSave.recomSpeechTherapy.map((x) => ({ recomSpeechTherapyId: x }));
        itemToSave.files = itemToSave.files.filter((x) => x.fileId);
        //--

        let obj = {conclusion: itemToSave, id: this.pmpkId, journalId: this.journalId };
        console.log(obj, "---- toSave");
        Api.saveConclusion(this.pmpkId, obj)
            .then(() => {
                Constants.alert.fire("Сохранено", "Заключение успешно сохранено", "success").then(() => {
                    this.$emit('save');
                });
            })
            .catch((res) => {
                console.log(res);
                Constants.alert.fire("Ошибка", res, "error");
                //this.resetCard();
            })
            .finally(() => {
                this.inProgress = false;
            });
      }
    },
    setup: () => ({ v$: useVuelidate() }),
    validations() {
    return {
      item: {
          number: {
            required,
            maxLength: maxLength(100),
          },
          passDate: {
            required,
          },
          pmpkPlacementId: {
            required,
          },
          districtId: {
            required: requiredIf(this.item?.pmpkPlacementId === "2"),
          },
          commissionConclusions: {
            required,
          },
          educationalProgramId: {
            required,
          },
          realizationTermId: {
            required,
          },
          repeatPeriodId: {
            required,
          },
          // parentConsentId: {
          //   required
          // },
          consentToAddId: {
            required,
          },
      },
    };
  },
  }
</script>

<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";
    .scrollable-content {
        overflow-y: auto;
        max-height: calc(100vh - 250px);
    }
    .pmpk-view {
        max-width: 98%;
        padding-left: 3px;
    }
    .form-control-text {
        height: auto;
        background: #F5F5FA;
        min-height: calc(2.25rem + 2px);
    }
    .form-group.required .control-label:after {
    content: " *";
    color: red;
    }
    .invalid-msg {
    color: red;
    }
    .btn-addFile {
    margin-top: 16px;
    padding: 0;
    width: 100%;
    text-align: left;
    font-family: "Source Sans Pro", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 120%;
    color: $blue-light;
    }
</style>
